export default function Required(target: any, prop: string) {
  const NG_ON_ONIT_NAME = 'ngOnInit';

  /** ngOnInit might not be implemented by this component */
  const ngOnInitClone = target[NG_ON_ONIT_NAME];

  /*Object.defineProperty(target, NG_ON_ONIT_NAME, {
    configurable: true,
    value() {

      if (this[prop] == null) {
        console.error(`${target.constructor.name}: ${prop} is required, but was not provided`);
      }
      if (ngOnInitClone) {
        ngOnInitClone.call(this);
      }
    }
  });*/
}
